import styled, { css } from 'styled-components';
import Colors from '@/v2/constants/Colors';

export const Container = styled.div`
  background-color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;

  border-radius: 12px;

  box-shadow: 0px 3.22px 6.43px 0px #1f293714;
  border: 2px solid ${Colors.NEUTRAL_VARIANTS[20]};

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
      :hover {
        border: 2px solid ${Colors.MAIN_VARIANTS[60]};
        background-color: ${Colors.MAIN_VARIANTS[10]};
      }
    `}
`;
